import { Query } from 'history';
import Queue from 'promise-queue';
import * as sessionsAPI from 'login-apis/sessionsAPI';
import * as stateUtils from './stateUtils';

// If we send a session update and then send another before the first request has returned,
// we run into a race condition where the second set of data is added to the session before it
// contains the first set of data, so the first set of data is not persisted to the session. So
// we queue requests so they are executed one at a time.
const maxConcurrent = 1;
const maxQueue = Infinity;
// exported for tests
export const sessionUpdateQueue = new Queue(maxConcurrent, maxQueue);

export async function saveQueryToSession(query: Query) {
  const sessionData = stateUtils.getOptionalCreationParams(query, [
    // NOTE: these values will be sent to analytics collectors. Do not include PII or sensitive information.
    'referrerId',
    'referringRealtor',
    'app_source',
    'applicationTemplateId',
    'displayLink',
    'comid',
    'loanType',
    'utm_source',
    'utm_medium',
    'utm_campaign',
    'utm_term',
    'utm_content',
    'signupUrl',
  ]);

  sessionUpdateQueue.add(() => sessionsAPI.sendData(sessionData));
}
